// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChannelChatInfo__container-f7f254 {
  display: inline-flex;
  align-items: center;
  overflow: hidden;
}

.ChannelChatInfo__group-info-d8d45a {
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 8px;
  border-radius: 16px;
  cursor: pointer;
}

.ChannelChatInfo__group-info-d8d45a:hover {
  background-color: var(--base-10);
}

.ChannelChatInfo__back-button-eee6e0 {
  margin: 0 8px;
}

.ChannelChatInfo__content-b92003 {
  display: flex;
  flex-direction: column;
  margin-inline-start: 12px;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
}

.ChannelChatInfo__title-wrapper-a50f29 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.ChannelChatInfo__title-d150ad {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ChannelChatInfo__members-count-ecf60e {
  text-align: left;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/ChannelChatInfo/ChannelChatInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  display: inline-flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.group-info {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  padding: 8px;\n  border-radius: 16px;\n  cursor: pointer;\n}\n\n.group-info:hover {\n  background-color: var(--base-10);\n}\n\n.back-button {\n  margin: 0 8px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  margin-inline-start: 12px;\n  justify-content: space-between;\n  align-items: flex-start;\n  overflow: hidden;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.members-count {\n  text-align: left;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChannelChatInfo__container-f7f254`,
	"group-info": `ChannelChatInfo__group-info-d8d45a`,
	"groupInfo": `ChannelChatInfo__group-info-d8d45a`,
	"back-button": `ChannelChatInfo__back-button-eee6e0`,
	"backButton": `ChannelChatInfo__back-button-eee6e0`,
	"content": `ChannelChatInfo__content-b92003`,
	"title-wrapper": `ChannelChatInfo__title-wrapper-a50f29`,
	"titleWrapper": `ChannelChatInfo__title-wrapper-a50f29`,
	"title": `ChannelChatInfo__title-d150ad`,
	"members-count": `ChannelChatInfo__members-count-ecf60e`,
	"membersCount": `ChannelChatInfo__members-count-ecf60e`
};
module.exports = ___CSS_LOADER_EXPORT___;
